import "./Panel.css";
"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.function.name");

var _TabPanel = _interopRequireDefault(require("../TabPanel"));

var _component = require("../_utils/component");

var _vueNormalizeComponent = _interopRequireDefault(require("../_utils/vue-normalize-component.js"));

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var __vue_script__ = {
  name: (0, _component.createComponentName)('editor-sidebar-panel'),
  components: {
    TabPanel: _TabPanel.default
  },
  mixins: [_component.componentMixin],
  props: {
    name: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      isMounted: false
    };
  },

  mounted() {
    this.isMounted = true;
  }

};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("tab-panel", _vm._g({
    class: _vm.bem(),
    attrs: {
      name: _vm.name
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn(ref) {
        var active = ref.active;
        return _c("div", {
          class: _vm.bem("tab")
        }, [_vm._t("tab", null, {
          active: active
        })], 2);
      }
    }], null, true)
  }, _vm.$listeners), [_vm._v(" "), _c("div", [_vm.title || _vm.$slots.title ? _c("div", {
    class: _vm.bem("title")
  }, [_vm._t("title", [_vm._v("\n                " + _vm._s(_vm.title) + "\n            ")])], 2) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

/* style inject */

/* style inject SSR */
var _default = (0, _vueNormalizeComponent.default)({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

exports.default = _default;